@if(loader.loading()){
  <div class="global-loader">
    <kendo-loader
      type="infinite-spinner"
      themeColor="primary"
      size="large">
    </kendo-loader>

    <div style="margin-top:12px; font-weight:500;">
      {{ loader.message() }}
    </div>
  </div>
}
<div class="rounded-box">
  <div class="column">
    <p><b>Name:</b> {{patientSearch.fname}} {{patientSearch.mname}} {{patientSearch.lname}} {{patientSearch.suffix}}</p>
    <p><b>Address:</b> {{patientSearch.street !== null ? patientSearch.street : ''}}
    {{patientSearch.city !== null ? patientSearch.city : ''}}
    {{patientSearch.state !== undefined ? patientSearch.state : ''}}
  {{patientSearch.zip !== null ? patientSearch.zip : ''}}</p>
  <p><b>DOB:</b> {{patientSearch.dob !== null ? (patientSearch.dob | convertDob) : ''}}</p>
  <p><b>Gender:</b> {{patientSearch.gender !== null ? (patientSearch.gender) : ''}}</p>
<!--    | phoneFormat-->
  <p><b>Phone:</b> {{patientSearch.phone !== null ? (patientSearch.phone) : ''}}</p>
    <p><b>MRN:</b> {{patientSearch.mrn !== null ? (patientSearch.mrn) : ''}}</p>
</div>
<div class="align-end">
  <button kendoButton themeColor="primary" (click)="select('create_new', null)">Create New Patient</button>
</div>
</div>
<div>
  <p>Found <b>{{matches.length}} Results</b></p>
  @if (matches.length > 0) {
    <kendo-grid [kendoGridBinding]="matches" [isDetailExpanded]="expandDetails">
      <kendo-grid-column field="Score" [width]="80">
        <ng-template kendoGridCellTemplate let-dataItem>
          <div>{{dataItem.score | percent:'1.2'}}</div>
        </ng-template>
      </kendo-grid-column>
      <kendo-grid-column field="Name" [width]="200">
        <ng-template kendoGridCellTemplate let-dataItem>
          <div [ngClass]="PatientSearchUtil.compareStrings(dataItem.fname, patientSearch.fname, false)">{{dataItem.fname}}</div>
          <div [ngClass]="PatientSearchUtil.compareStrings(dataItem.mname, patientSearch.mname, false)">{{dataItem.mname}}</div>
          <div [ngClass]="PatientSearchUtil.compareStrings(dataItem.lname, patientSearch.lname, false)">{{dataItem.lname}}</div>
          <div [ngClass]="PatientSearchUtil.compareStrings(dataItem.suffix, patientSearch.suffix, false)">{{dataItem.suffix}}</div>
        </ng-template>
      </kendo-grid-column>
      <kendo-grid-column field="Address" [width]="120">
        <ng-template kendoGridCellTemplate let-dataItem>
          <div [ngClass]="PatientSearchUtil.compareStrings(dataItem.street, patientSearch.street, false)">{{dataItem.street}}</div>
          <div [ngClass]="PatientSearchUtil.compareStrings(dataItem.city, patientSearch.city, false)">{{dataItem.city}}</div>
          <div [ngClass]="PatientSearchUtil.compareStrings(dataItem.state, patientSearch.state, false)">{{dataItem.state}}</div>
          <div [ngClass]="PatientSearchUtil.compareStrings(dataItem.zip, patientSearch.zip, false)">{{dataItem.zip}}</div>
        </ng-template>
      </kendo-grid-column>
      <kendo-grid-column field="DOB" [width]="80">
        <ng-template kendoGridCellTemplate let-dataItem>
          <div [ngClass]="PatientSearchUtil.compareStrings(dataItem.dob, patientSearch.dob, true)">{{dataItem.dob | convertDob}}</div>
        </ng-template>
      </kendo-grid-column>
      <kendo-grid-column field="Gender" [width]="100">
        <ng-template kendoGridCellTemplate let-dataItem>
          <div [ngClass]="PatientSearchUtil.compareStrings(dataItem.gender, patientSearch.gender, false)">{{dataItem.gender}}</div>
        </ng-template>
      </kendo-grid-column>
      <kendo-grid-column field="Phone" [width]="100">
        <ng-template kendoGridCellTemplate let-dataItem>
<!--          | phoneFormat-->
          <div [ngClass]="PatientSearchUtil.compareStrings(dataItem.phone, patientSearch.phone, false)">{{dataItem.phone | phoneFormat}}</div>
        </ng-template>
      </kendo-grid-column>
      <kendo-grid-column field="Select" [width]="80">
        <ng-template kendoGridCellTemplate let-dataItem>
          <button kendoButton themeColor="primary" (click)="select('matched', dataItem)">Select</button>
        </ng-template>
      </kendo-grid-column>
      <ng-template kendoGridDetailTemplate let-dataItem>
        <p>Patient Forms: </p>
        <div class="legend example-config">
          <span class="legend-item">
            <span class="legend-color" [style.backgroundColor]="'#198754'"></span>
            POLST
          </span>
          <span class="legend-item">
            <span class="legend-color" [style.backgroundColor]="'#fff9c4'"></span>
            Latest Rejected POLST
          </span>
        </div>
        <kendo-grid [kendoGridBinding]="dataItem.forms">
          <kendo-grid-column field="Type" [width]="70">
            <ng-template kendoGridCellTemplate let-dataItem>
              <span class="whole-cell" [style.backgroundColor]="columnColor(dataItem)">
                {{dataItem.type}}
              </span>
            </ng-template>
          </kendo-grid-column>
          <kendo-grid-column field="Current" [width]="20">
            <ng-template kendoGridCellTemplate let-dataItem>
              <span class="whole-cell" [style.backgroundColor]="columnColor(dataItem)">
                @if (dataItem.current) {
                  <div>Yes</div>
                }
                @if (!dataItem.current) {
                  <div style="color: #d9534f"><b>No</b></div>
                }
              </span>
            </ng-template>
          </kendo-grid-column>
          <kendo-grid-column field="Document Date" [width]="20">
            <ng-template kendoGridCellTemplate let-dataItem>
              <span class="whole-cell" [style.backgroundColor]="columnColor(dataItem)">
                {{dataItem.doc_date | convertUtcNoTime}}
              </span>
            </ng-template>
          </kendo-grid-column>
          <kendo-grid-column field="View Form" [width]="20">
            <ng-template kendoGridCellTemplate let-dataItem>
              <button kendoButton themeColor="primary" (click)="viewForm(dataItem)">View</button>
            </ng-template>
          </kendo-grid-column>
        </kendo-grid>
      </ng-template>
    </kendo-grid>
  }
</div>
